import { NavLink, useLocation } from 'react-router-dom';
import './TabBar.css';

interface Tab {
  path: string;
  label: string;
  icon: string; // emoji for now; SVG later
}

const TABS: Tab[] = [
  { path: '/', label: 'Home', icon: '🏠' },
  { path: '/plan', label: 'Plan', icon: '🧭' },
  { path: '/map', label: 'Map', icon: '🌍' },
  { path: '/alerts', label: 'Alerts', icon: '⚠' },
  { path: '/settings', label: 'Settings', icon: '⚙' },
];

export function TabBar() {
  const location = useLocation();

  return (
    <nav className="tab-bar" role="navigation" aria-label="Main navigation">
      {TABS.map((tab) => (
        <NavLink
          key={tab.path}
          to={tab.path}
          className={({ isActive }) => `tab-bar__link${isActive ? ' tab-bar__link--active' : ''}`}
          end={tab.path === '/'}
        >
          <span className="tab-bar__icon" aria-hidden="true">{tab.icon}</span>
          <span className="tab-bar__label">{tab.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
